import React, { useState } from 'react';
import './App.css';
import QueryBot from './containers/QueryBot/QueryBot';

function App() {

  const [isLigoOpen, setisLigoOpen] = useState(false);
  const [cautionPopup, setCautionPopup] = useState(true);

  return (
    <div className="App">
      {
        cautionPopup ?
          <div>
            <div id='caution-backdrop'></div>
            <div id='caution'>
              <b>NOTE:</b> <p>This is my first practice project in ReactJS named "Query bot". Its a static data which i created and been using. I use this as showcase of my experties in front-end developing / UI designing.</p>
              <div id='caution-button' onClick={() => { setCautionPopup(false) }}>View project</div>
            </div>
          </div>
          :
          <QueryBot isligoOPen={isLigoOpen} openLigo={() => { isLigoOpen ? setisLigoOpen(false) : setisLigoOpen(true) }} />
      }
    </div>
  );
}

export default App;
